// Which row actions an order permits — mirrors what the delete route itself rejects.
const hasAllocations = (row) => Boolean(row?.hasAllocations);

export const ORDER_ACTIONS = Object.freeze({
  delete: { disabled: hasAllocations },
});
